<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 受付中の予約状況の確定・落選の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>受付中の予約状況の確定・落選の説明</span></mat-card-title>
      </mat-card-header>

      <!-- 予約説明 -->
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/confirm-reservation-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png">条件
        </div>
        <div class="manual-explain">
          予約施設：<br>
          予約施設を表示します。<br>
          利用日：<br>
          予約の利用日を表示します。<br>
          利用時間：<br>
          予約の利用時間を表示します。<br>
          残予約数：<br>
          利用日と利用時間に該当する予約の残り予約数を表示します。<br>
          抽選日：<br>
          自動抽選の実行日を表示します。予約施設の予約方式が「抽選」の場合に表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png">抽選ボタン
        </div>
        <div class="manual-explain">
          利用日と利用時間に該当する予約の抽選を即座に実行します。予約施設の予約方式が「抽選」の場合に表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 予約一覧
        </div>
        <div class="manual-explain">
          利用日と利用時間に該当する予約の一覧が表示されます。<br>
          編集アイコンをクリックすることで<a [href]="comfrmReservationDeiatilDialogLink">予約状況編集画面</a>が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Confirm/Rejection of reservations in progress
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Confirm/Rejection of reservations in progress</span></mat-card-title>
      </mat-card-header>

      <!-- 予約説明 -->
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_confirm-reservation-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Conditions
        </div>
        <div class="manual-explain">
          Reserved Facility:<br>
          Displays the reserved facility.<br>
          Usage Date:<br>
          Displays the usage date of the reservation.<br>
          Usage Time:<br>
          Displays the usage time of the reservation.<br>
          Remaining Reservations:<br>
          Displays the remaining number of reservations for the corresponding usage date and time.<br>
          Lottery Date:<br>
          Displays the execution date for automatic lottery. This is displayed when the reservation method of the reserved facility is "Lottery".<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Lottery Button
        </div>
        <div class="manual-explain">
          Immediately executes the lottery for reservations corresponding to the usage date and time. This is displayed when the reservation method of the reserved facility is "Lottery".<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Reservation List
        </div>
        <div class="manual-explain">
          Displays a list of reservations corresponding to the usage date and time.<br>
          Click the edit icon to display the <a [href]="comfrmReservationDeiatilDialogLink">Reservation Status Edit Screen</a>.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
